import React, { useLayoutEffect, useRef } from "react";

interface BoxCardProps {
  className?: string;
  title?: React.ReactNode;
  actions?: React.ReactNode;
  content?: React.ReactNode;
  contentClassName?: string;
  rowThreshold?: String;
  noPadding?: boolean;
}

const BoxCard: React.FC<BoxCardProps> = ({ className, title, actions, content, contentClassName, rowThreshold, noPadding }) => {
  const cardRef = useRef(null);

  useLayoutEffect(() => {
    const card = cardRef.current;
    if (!card || typeof card.animate !== "function") return;
    if (typeof window.matchMedia === "function" && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    const { left, top } = card.getBoundingClientRect();
    const delay = Math.min(240, (Math.max(0, left) + Math.max(0, top)) * 0.08);
    const animation = card.animate(
      [
        { opacity: 0, transform: "translateX(24px)" },
        { opacity: 1, transform: "none" },
      ],
      { duration: 300, delay, easing: "ease-out", fill: "backwards" },
    );

    return () => animation.cancel();
  }, []);

  return (
    <div
      ref={cardRef}
      className={"card d-flex flex-column m-2 " + (!noPadding ? "p-3 pt-2 " : "") + (content || !noPadding ? "" : "pb-2 ") + (className ? className : "")}
      style={{
        borderWidth: "1px",
        borderStyle: "solid",
        borderImageSlice: 1,
        backgroundColor: "#2c2f33",
        color: "#e0e0e0",
        maxWidth: "stretch"
      }}
    >
      {(title || actions) && (
        <div className={"d-flex " + (rowThreshold ? "flex-"+rowThreshold+"-row" : "flex-row")}>
          <div className="d-flex align-items-center">
            <h4 className={"flex-grow-1 " + (content ? "" : "mb-0")}>{title}</h4>
          </div>

          <div className="d-flex flex-fill overflow-hidden justify-content-end align-items-center">{actions}</div>
        </div>
      )}

      <div className={"d-flex flex-fill " + (contentClassName ? contentClassName : "")}>{content}</div>
    </div>
  );
};

export default BoxCard;
